module.exports = __webpack_public_path__ + "img/4.07.thmb.xs.305a58f4.jpg";